// extracted by mini-css-extract-plugin
export default {"instructions":"styles_instructions__qmHg0"};